import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const AccountEvents = eventGroup({
  source: 'Account Events',
  events: {
    LoggedOut: type<void>(),
  },
});
